import Onboarding from './Onboarding.vue';

export default Onboarding;
